import * as Icons from "lucide-react";
import { SOLUTIONS, BRAND } from "@/lib/brand";
import { ArrowUpRight, MessageCircle } from "lucide-react";

export const Solutions = () => {
  return (
    <section
      id="solucoes"
      data-testid="solutions-section"
      className="relative py-24 lg:py-32 bg-mist"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Soluções Corporativas e Industriais</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="solutions-title"
            >
              Muito além do fornecimento.
              <br />
              Somos parceiros estratégicos.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-lg text-slate-600 leading-relaxed reveal">
              Do diagnóstico técnico à entrega no seu almoxarifado, a Imporparts sustenta a
              produção de indústrias que <strong className="text-navy">não podem parar</strong>.
            </p>
            <a
              href={BRAND.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="solutions-cta"
              className="btn-primary mt-6 text-sm reveal"
            >
              <MessageCircle className="w-4 h-4" /> Falar com um especialista
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {SOLUTIONS.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Cog;
            return (
              <div
                key={s.title}
                data-testid={`solution-card-${i}`}
                className="reveal card-lift group relative rounded-2xl bg-white border border-slate-200 p-6 lg:p-7 overflow-hidden"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center group-hover:bg-gold transition-colors">
                    <Icon className="w-5 h-5" />
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-slate-300 group-hover:text-gold transition-colors" />
                </div>
                <div className="font-display text-lg font-semibold text-navy leading-snug mb-2">
                  {s.title}
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <div className="mt-5 h-px w-full bg-gradient-to-r from-slate-200 to-transparent" />
                <div className="mt-3 text-[10px] tracking-[0.22em] uppercase font-semibold text-slate-400">
                  0{i + 1} · Solução
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
